import React from 'react';
import { LEARN_CONTENT } from './LearnContent';

const LearnArticle = ({ article, onBack, onGetStarted, onArticleClick }) => {
  if (!article) return null;

  // Intercept clicks on links inside the article
  const handleContentClick = (e) => {
    const target = e.target.closest('a');
    // If it's an internal link (starts with /learn/), we handle it via React state
    if (target && target.getAttribute('href').startsWith('/learn/')) {
      e.preventDefault();
      const slug = target.getAttribute('href').split('/').pop();
      const linkedArticle = LEARN_CONTENT.find(a => a.slug === slug);
      if (linkedArticle && onArticleClick) {
        onArticleClick(linkedArticle);
      }
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.nav}>
        <button onClick={onBack} style={styles.backBtn}>← Back to Hub</button>
      </div>

      <article style={styles.articleWrapper}>
        <span style={{ ...styles.category, color: article.accent }}>{article.category}</span>
        <h1 style={styles.title}>{article.title}</h1>
        
        <div 
          style={styles.contentBody}
          onClick={handleContentClick} // Listener added here
          dangerouslySetInnerHTML={{ __html: article.content }} 
        />
        
        <div style={styles.footerCTA}>
          <h3 style={styles.ctaHeading}>{article.ctaTitle}</h3>
          <p style={styles.ctaSubtext}>{article.ctaSubtitle}</p>
          <button onClick={onGetStarted} style={styles.ctaButton}>
            Launch Terminal
          </button>
        </div>
      </article>

      <style>{`
        h2 { color: #fff; margin-top: 40px; font-size: 28px; font-weight: 800; line-height: 1.3; }
        h3 { color: #fff; margin-top: 30px; font-size: 22px; font-weight: 700; }
        p { color: #94a3b8; line-height: 1.8; font-size: 17px; margin-bottom: 20px; }
        .pro-tip { background: rgba(56, 189, 248, 0.05); border-left: 4px solid #38bdf8; padding: 25px; border-radius: 12px; margin: 35px 0; }
        .pro-tip strong { color: #38bdf8; display: block; margin-bottom: 5px; font-size: 14px; text-transform: uppercase; }
        
        .who-is-this-for { background: #0d1117; padding: 25px; border-radius: 12px; border: 1px solid #1e293b; margin-bottom: 40px; }
        .who-is-this-for strong { color: #fff; display: block; margin-bottom: 10px; }
        .who-is-this-for ul { color: #94a3b8; padding-left: 20px; }
        .who-is-this-for li { margin-bottom: 8px; }
        
        .internal-link { margin-top: 40px; padding-top: 20px; border-top: 1px solid #1e293b; font-size: 14px; }
        .internal-link span { color: #64748b; margin-right: 10px; }
        .internal-link a { color: #38bdf8; text-decoration: none; font-weight: 700; cursor: pointer; }
        .internal-link a:hover { text-decoration: underline; }
      `}</style>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#000', color: '#fff', padding: '40px 20px' },
  nav: { maxWidth: '800px', margin: '0 auto 40px' },
  backBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontWeight: '700', fontSize: '15px' },
  articleWrapper: { maxWidth: '800px', margin: '0 auto' },
  category: { fontWeight: '800', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '1px' },
  title: { fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: '900', marginTop: '10px', marginBottom: '50px', lineHeight: '1.1', letterSpacing: '-1.5px' },
  contentBody: { marginBottom: '60px' },
  footerCTA: { marginTop: '100px', padding: '50px 30px', background: '#0d1117', borderRadius: '24px', textAlign: 'center', border: '1px solid #1e293b' },
  ctaHeading: { fontSize: '28px', fontWeight: '800', marginBottom: '10px' },
  ctaSubtext: { color: '#94a3b8', marginBottom: '30px' },
  ctaButton: { background: '#38bdf8', color: '#000', border: 'none', padding: '16px 36px', borderRadius: '12px', fontWeight: '900', fontSize: '16px', cursor: 'pointer' }
};

export default LearnArticle;